<template>
  <div class="page">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LayoutPage',
};
</script>

<style scoped lang="scss">
.page {
  $margin: 5rem;
  $header-height: 5rem;
  background-color: $color-purple--100;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  @include media-breakpoint-up(md) {
    margin: $header-height 0 0 0;
    min-height: calc(100vh - #{$margin});
  }
}
</style>
